import { useEffect } from "react";

/**
 * Feature 5 - Disable Right Click.
 *
 * Prevents the context menu on the protected target (image save / copy /
 * inspect selection). Scoped to the target element when provided, otherwise the
 * document. When `enabled` is false, does nothing.
 *
 * @param {object} opts
 * @param {boolean} opts.enabled
 * @param {() => HTMLElement|null} [opts.getTarget]
 * @param {() => void} [opts.onBlocked]
 */
export function useContextMenuGuard({ enabled, getTarget, onBlocked } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const target = (getTarget && getTarget()) || document;

    const handler = (e) => {
      e.preventDefault();
      if (typeof onBlocked === "function") onBlocked();
      return false;
    };

    target.addEventListener("contextmenu", handler, false);
    return () => target.removeEventListener("contextmenu", handler, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
}

export default useContextMenuGuard;
